import { render, staticRenderFns } from "./transcript-recommendation-box.vue?vue&type=template&id=d42e9af4&scoped=true&"
import script from "./transcript-recommendation-box.vue?vue&type=script&lang=js&"
export * from "./transcript-recommendation-box.vue?vue&type=script&lang=js&"
import style0 from "./transcript-recommendation-box.vue?vue&type=style&index=0&id=d42e9af4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d42e9af4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d42e9af4')) {
      api.createRecord('d42e9af4', component.options)
    } else {
      api.reload('d42e9af4', component.options)
    }
    module.hot.accept("./transcript-recommendation-box.vue?vue&type=template&id=d42e9af4&scoped=true&", function () {
      api.rerender('d42e9af4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/crm/components/transcript-recommendation-box/transcript-recommendation-box.vue"
export default component.exports